<template>
  <div :class="classList" v-bind="$props" v-on="$listeners">
    <slot></slot>
  </div>
</template>

<script lang="ts">
  import mixins from '../../mixins';

  export default mixins().extend({
    props: {
      value: { default: true, type: Boolean },
    },
    computed: {
      classList() {
        return ({
          'p-overlay': true,
          visible: this.value,
        });
      },
    },
  });
</script>
